import config from '../config.general';
import {
	mcProgressAppName,
	betterOffAppName,
	betterOffCommunityFeed,
	kpCommunityFeed,
	kellyPartnersPassportAppName
} from './constants';

export const isMcProgressApp = () => config.appName === mcProgressAppName;
export const isBetterOffApp = () => config.appName === betterOffAppName;
export const isKpPassportApp = () => config.appName === kellyPartnersPassportAppName;
export const getCommunityFeedName = () =>
	config.appName === betterOffAppName ? betterOffCommunityFeed : kpCommunityFeed;

export const getAppDisplayName = () => {
	if (isMcProgressApp()) return 'Progress AI';
	if (isBetterOffApp()) return 'Be Better Off';
	return config.appName;
};
